import React from 'react';
import { connect } from 'react-redux';


import { MuiThemeProvider, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import * as M from '@material-ui/core';

import Typography from '@material-ui/core/Typography';

import { Actions, AppState, IPageState, store } from '../../appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Trans } from 'react-i18next';

import BackspaceIcon from '@mui/icons-material/Backspace';

import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { AsortGrupyWiersz } from 'api';
import roomImg from 'app/assets/noImage.jpg';
import CONFIG from '../../cfg/config';
import { Card, CardActions, Fab, FormControl, Grid, TextField } from '@material-ui/core';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import {AddItem} from '../PanelRightBasket';
import { fontSelect } from '../../fonts';
import theme from 'themes';
import { FormikFieldNames, FormularzLabels } from 'app/formularz/formularzStale';
import MapContainer, { MapData } from 'app/map_new/MapContainer';
import themeDialog from 'themes-dialog';

export const ThemeOrange = M.createTheme({
  palette: {
    primary: {
      main: "#e65100",
    },
    secondary: {
      main: "#3a87ad",
    },
  },
});




interface DialogErrorProps extends WithStyles<typeof styles>  {
  //classes?: any,
  page: IPageState,

  open: boolean,
  
  setAdress: (field: string, value: any, shouldValidate?: boolean | undefined) => void,
  close: (focusNext: boolean) => void,
  //confirm: () => void,
  
  title: string,
  
  
}

class DialogError extends React.Component<DialogErrorProps, any> {

  constructor(props: any) {
    super(props, {});
  }
  state = {
   
  };


  setAdress = () => {
    this.props.setAdress(FormikFieldNames.Adres, this.props.page.map.klientAdres, true)
    this.props.close(true)
  }

  close = (bool: boolean) => {
    this.props.close(bool)
    let d = new MapData({ 
      obiektGPS: this.props.page.map.obiektGPS, 
      obiektLat: this.props.page.map.obiektLat, 
      obiektLng: this.props.page.map.obiektLng,
      klientAdres: '',
      distance: 0,
      klientGPS: '',
      klientLat: 0,
      klientLng:  0,
      dokNr: '',
   })
  store.dispatch(Actions.pageState.setMap(d, true));
  }


  render() {
    const classes = this.props.classes;

    return (

      <Dialog
        //disableEscapeKeyDown
        //maxWidth="md"
        classes={{paper: classes.paper}}
        open={this.props.open}
        onClose={() => this.close(false)}
        fullWidth               
      >
        {/* <DialogTitle disableTypography style={{paddingBottom: "12px"}}>
          <Typography gutterBottom variant="h5" component="h2" color='primary' style={{ fontSize: "1.25rem" }} >
            <b>{this.props.title}</b>
          </Typography>
          <hr />
        </DialogTitle>

        <DialogContent  > */}

        <ThemeProvider theme={themeDialog}>  
            <MapContainer />
        </ThemeProvider>
        {this.props.page.map.klientLat ? <Fab
          className="mapOk"
          style={{ fontSize: "14px" }}
          color="primary"
          //aria-label="dodaj"
          onClick={this.setAdress}
        >
          {<Trans>OK</Trans>}
        </Fab> : null}
       
        <MuiThemeProvider theme={ThemeOrange}>
        <Fab
          className="mapBack"
          style={{ fontSize: "14px" }}
          color="primary"
          //aria-label="dodaj"
          onClick={() => this.close(false)}
        >
          {<Trans>Back</Trans>}
        </Fab> 
        </MuiThemeProvider>
          
        {/* </DialogContent > */}
        {/* <DialogActions >

            <Button onClick={() => this.props.close(false)} variant="outlined" size="small" color="primary"
              style={{ textTransform: "none", fontSize: "0.8rem" }}
            >
                 
                 <b><Trans>Back</Trans></b>
             
            </Button>
            <Button  variant="contained" size="small" color="primary" onClick={this.setAdress}
              style={{ textTransform: "none", fontSize: "0.8rem" }}
            >
              <b><Trans>OK</Trans></b> 
              
            </Button>
         
         
        </DialogActions> */}
      </Dialog>

    );
  }
}

const styles = (theme: Theme) => ({
  paper: {
    //maxWidth: "350px"
    width: "100%",
    height: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    margin: 0,
    borderRadius: "0"
  },
  primary: {
    color: theme.palette.primary.main
  },
  actionButtons: {
    textTransform: "lowercase" as "lowercase",
    fontSize: '0.8rem'
  },
  button: {
    width: "100%",
    height: "45px",
    textTransform: "none" as "none", 
    fontSize: "1.25rem"
  },
  primaryTextField: {
    color: theme.palette.primary.main,
    backgroundColor: "white",
    textAlign: 'left' as 'left',
    fontSize: "1rem"
},

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(DialogError));